define(['underscore', 'edge/platform/base/BaseCtrl', 'text!../views/membership-confirmation.html'], (_, BaseCtrl, membershipDetailTemplate)=> {
    // added membership confirmation template - QnB Issue with payment amount not updating – DFCT0020740
    // added '$rootScope' *Princy UI
    const fn = ($scope, $rootScope, $filter, $timeout, LocaleService, InsuranceSuiteMetadata, StateUtils, submissionViewModel, VinLookupService, VinLookupEnabled, $q, ModalService,$state,InMemorySession,LoadSaveService,MembershipService)=> {
        const ctrl = Object.create(BaseCtrl);
        const submissionVM = submissionViewModel();
        const chosenQuoteId = StateUtils.activeDataForState(true).model.value.quoteData.offeredQuotes[0].publicID;
        const driver = angular.copy(submissionVM.draftData.lobs.personalAuto.value.drivers);
        const vehicles = angular.copy(submissionVM.draftData.lobs.personalAuto.value.vehicles);
        const flowModel = StateUtils.activeDataForState(true).flowModel;
        var vinArray = [];
        var driverLicenseArr = [];
        const policyAddress = angular.copy(submissionVM.draftData.policyAddress.value);
        
        ///////////////////////////////////////////////////////////////
        //submissionVM.draftData.value = InMemorySession.getDraftData();
        ///////////////////////////////////////////////////////////////
        ctrl.init = ()=> {

            $scope.skip = true;
            ctrl._setBindDataDefaultValues();
            if(ctrl.skipOnResume()){
                flowModel.next(submissionVM);
            }
            $scope.$filter = $filter;
            $scope.startDate = new Date();
            $scope.disabled = false;
            $scope.vehicleVinValidMap = [];
            $scope.states = InsuranceSuiteMetadata.get('pc').types.getTypelist('State').codes;
            $scope.bindData = submissionVM.bindData;
            $scope.bindData.chosenQuote.value = chosenQuoteId;
            $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
            $scope.leaseOptions = [{ name: "Other"}];
            $scope.leaseSelectedOption = $scope.leaseOptions[0];
            $scope.financeOptions = [{ name: "Other"}];
            $scope.financeSelectedOption = $scope.financeOptions[0];
            $scope.displayLeaseCompanyInput=false;
            $scope.displayFinanceCompanyInput=false;
            $scope.showCoverages = true;
            $scope.invalidVIN = false;
            $scope.chosenQuoteData = _.findWhere(submissionVM.quoteData.offeredQuotes.value, {publicID: chosenQuoteId});
            $scope.vinFlagArray = [];
            $scope.licenseNumberFlagArray = [];
            $scope.displayVehiclesFeatures = 0;
            $scope.prefillResponseFromFactory = InMemorySession.getPrefillData();
            //$scope.driverFlagPrefillArray = []; // driverFlagPrefillArray added *Princy UI
            //$scope.vehicleFlagPrefillArray = []; // vehicleFlagPrefillArray added *Princy
            _.forEach(vehicles,function(item){
                let vin_no = item.isPrefilledVehicle ? InMemorySession.decryptData(item.encryptedVIN) : item.vin;
                if(vin_no && vin_no.length === 17){
                    $scope.vinFlagArray.push(true);
                    // added vehiclePrefill Flag Array *Princy
                    //$scope.vehicleFlagPrefillArray.push(item.publicID)
                }else {
                    $scope.vinFlagArray.push(false);
                }
                vinArray.push(vin_no);
            });

            _.forEach(driver,function(item){
                let licenseno = item.isPrefilledDriver ? InMemorySession.decryptData(item.eNCLicenseNumber) : item.licenseNumber;
                if(licenseno){
                    $scope.licenseNumberFlagArray.push(true);
                    // added driverPrefill Flag Array *Princy UI
                   //$scope.driverFlagPrefillArray.push(item.publicID);
                }else {
                    $scope.licenseNumberFlagArray.push(false);
                }
                driverLicenseArr.push(licenseno);
            });

            // added prefillDriver Flag and Vehicle Flag *Princy UI commented 68-69 coz of rootScope
           // $rootScope.prefillDrivers =  $scope.driverFlagPrefillArray;
            //$rootScope.prefillVehicles =  $scope.vehicleFlagPrefillArray;
            //devendra prefill code started
            $scope.prefillDriverCheck = function(driver,index){
                let isPrefilledDriverCheck = false;
                if($scope.prefillResponseFromFactory && $scope.prefillResponseFromFactory.drivers){
                    $scope.prefillResponseFromFactory.drivers.forEach((obj) => {
                        if(driver.person.firstName.value !== "undefined" && obj.dateOfBirth && ( driver.eNCDateOfBirth && (typeof driver.eNCDateOfBirth == 'string' || typeof driver.eNCDateOfBirth.value !== "undefined"))){
                            let encDob = InMemorySession.decryptData(driver.eNCDateOfBirth.value).split(' ')[0].split("-")
                            let d1 = new Date(encDob[0], encDob[1]-1, encDob[2]);
                            // let d1 = new Date(driver.dateOfBirth.year.value, driver.dateOfBirth.month.value, driver.dateOfBirth.day.value);
                            let d2 = obj.dateOfBirth;
                            d2.setHours(0, 0, 0, 0);
                            if(driver.person.firstName.value.toLowerCase() == obj.firstName.toLowerCase() && driver.person.lastName.value.toLowerCase() == obj.lastName.toLowerCase() && d1.getTime() == d2.getTime()){
                                isPrefilledDriverCheck = true;  
                            }
                        }                            
                    });
                }
                if(isPrefilledDriverCheck){
                    $scope.driversVM[index].value.isPrefilledDriver = true;
                }else{
                    $scope.driversVM[index].value.isPrefilledDriver = false;
                    $scope.allPrefillDriversFlag = false;
                }
            };
            $scope.prefillVehicleCheck = function(vehicle,index){
                let isPrefilledVehicleCheck = false;
                if($scope.prefillResponseFromFactory && $scope.prefillResponseFromFactory.vehicles){
                    $scope.prefillResponseFromFactory.vehicles.forEach((obj) => {
                        if(vehicle.encryptedVIN && ((typeof vehicle.encryptedVIN =='string' && obj.vin == vehicle.encryptedVIN) || (vehicle.encryptedVIN.value && obj.vin == vehicle.encryptedVIN.value)))
                        {
                            isPrefilledVehicleCheck = true;
                        }   
                    });
                }
                if(isPrefilledVehicleCheck){
                    $scope.vehiclesVM[index].isPrefilledVehicle = true;
                }else{
                    $scope.vehiclesVM[index].isPrefilledVehicle = false;
                    $scope.allPrefillVehicleFlag = false;
                }
            };
            //devendra prefill code end
            $scope.vehiclesVM = submissionVM.draftData.lobs.personalAuto.vehicles.children;
            $scope.driversVM = submissionVM.draftData.lobs.personalAuto.drivers.children;
            //devendra prefill code started
            $scope.allPrefillDriversFlag = true;
            if($scope.driversVM && $scope.driversVM.length > 0){
                for(let idxDriver in  $scope.driversVM){
                    if(typeof $scope.driversVM[parseInt(idxDriver)] != "undefined" && typeof $scope.prefillResponseFromFactory !== "undefined" && typeof $scope.prefillResponseFromFactory.drivers !== "undefined" && $scope.prefillResponseFromFactory.drivers.length > 0){
                        $scope.prefillDriverCheck($scope.driversVM[idxDriver],parseInt(idxDriver));
                    }else{
                        $scope.driversVM[idxDriver].isPrefilledDriver = false;
                        $scope.allPrefillDriversFlag = false;
                    }
                }
            }
            $scope.allPrefillVehicleFlag = true;
            if($scope.vehiclesVM && $scope.vehiclesVM.length > 0){
                for(let idxVehicle in  $scope.vehiclesVM){
                    if(typeof $scope.vehiclesVM[parseInt(idxVehicle)] != "undefined" && typeof $scope.prefillResponseFromFactory !== "undefined" && typeof $scope.prefillResponseFromFactory.vehicles !== "undefined" && $scope.prefillResponseFromFactory.vehicles.length > 0){
                        $scope.prefillVehicleCheck($scope.vehiclesVM[idxVehicle],parseInt(idxVehicle));
                    }else{
                        $scope.vehiclesVM[idxVehicle].isPrefilledVehicle = false;
                        $scope.allPrefillVehicleFlag = false;
                    }
                }
            }
            //devendra prefill code end
            //ctrl.initAdditionalInterestVM();
            $scope.draftData = submissionVM.draftData.value;
            //ENHC0011961 popup for membership validation
            membershipDetailCheck();
        };
        //ENHC0011961 popup for membership validation
        //added below codes for DFCT0020740 --Arpita
        function membershipDetailCheck(){
            let result = [];
            if(!$scope.draftData.accountHolder.membershipNumber){
                ModalService.showSimpleDialog(membershipDetailTemplate, submissionVM.value, {
                    quoteAsNonMember: ctrl._quoteAsNonMember,
                    showMemberWarning: ctrl._showMemberWarning,
                    membershipValidation: ctrl._membershipValidation
                }, null);
            }
        }
        //ended
         //Eodb - membership quote as non member --Arpita
         // added below codes from ModalCtrl.js to her as part of QnB Issue with payment amount not updating – DFCT0020740 --Arpita
        ctrl._quoteAsNonMember = function(dialogScope,formData){
            submissionVM.value.draftData.accountHolder.isMember = false;
            submissionVM.value.draftData.accountHolder.quoteAsAAAMember = false
            var saveQuotedSubmission = LoadSaveService.saveAndReQuoteSubmission(null, submissionVM.value);
            ModalService.showProgressDialog('quoteandbind.controllers.Please wait', saveQuotedSubmission);
            saveQuotedSubmission.then(nonMembershipResp => {
                submissionVM.value = nonMembershipResp
                dialogScope.$close();
            })
        }
        //ENHC0011961 - adding membership attention message ---Arpita Sengupta
        // added below codes from ModalCtrl.js to her as part of QnB Issue with payment amount not updating – DFCT0020740 --Arpita
        ctrl._showMemberWarning = function (dialogScope,formData){
            dialogScope.showMemberWarningMsg = false;
            if(null != formData.memberNumber.$modelValue && formData.memberNumber.$modelValue != '' && formData.memberNumber.$modelValue.length !=16) {
                dialogScope.showMemberWarningMsg = true;
            }
        
        };
        //ENHC0011961 - checking validation for Membership number - Arpita Sengupta
        // added below codes from ModalCtrl.js to her as part of QnB Issue with payment amount not updating – DFCT0020740 --Arpita
        ctrl._membershipValidation = function(dialogScope,formData){
            let membershipDetails = {membershipNumber: formData.memberNumber.$modelValue};
            dialogScope.showErrorMsg = false;
            dialogScope.showMemValidationError  = false;
            if (membershipDetails.membershipNumber != null && membershipDetails.membershipNumber != '' && membershipDetails.membershipNumber.length == '16'  ) {
                var membershipPromise = MembershipService.isMember('quoteandbind', membershipDetails);
                ModalService.showProgressDialog('quoteandbind.controllers.MembershipCtrl.Checking for membership', membershipPromise);
        
                membershipPromise.then(membershipResp => {
                    if( membershipResp[0].membershipStatus &&
                        membershipResp[0].firstName && membershipResp[0].lastName
                    ){
                        submissionVM.value.draftData.accountHolder.isMember = true;
                        submissionVM.value.draftData.accountHolder.quoteAsAAAMember = false
                        submissionVM.value.draftData.accountHolder.membershipNumber = membershipResp[0].membershipNumber;        
                        submissionVM.value.draftData.accountHolder.joinedYear = membershipResp[0].originalJoinYear;
                        submissionVM.value.draftData.accountHolder.membershipType = membershipResp[0].serviceLevel;
                        submissionVM.value.draftData.accountHolder.membershipStatus = membershipResp[0].membershipStatus;
                        
                        var saveQuotedSubmission = LoadSaveService.saveAndReQuoteSubmission(null, submissionVM.value);
                        ModalService.showProgressDialog('quoteandbind.controllers.Please wait', saveQuotedSubmission);
                        saveQuotedSubmission.then(reQuoteResponse => {
                            submissionVM.value = reQuoteResponse;
                        });
                        dialogScope.$close();
                    }
        
                }).catch(() => {
                    dialogScope.showMemValidationError = true;
                });
        
            }else{
                dialogScope.showErrorMsg = true;
            }
        }//ended


        ctrl.skipOnResume = function(){
            //skip this page
            //1.All the vehicles have valid Vin
            //2.All the drivers have driving license
            //3.bind data phone is available
            //4. email is available
            var validDrivers = true;
            var validVehicles = true;
            var phone =  submissionVM.bindData.contactPhone.value;
            var email =   submissionVM.bindData.contactEmail.value;
            _.forEach(driver,function(item){
                let licenseno = item.isPrefilledDriver ? InMemorySession.decryptData(item.eNCLicenseNumber) : item.licenseNumber;
                if(typeof licenseno === 'undefined' || licenseno === '' ) {
                    validDrivers = false
                }
            });

            _.forEach(vehicles,function(item){
                let vin_no = item.isPrefilledVehicle ? InMemorySession.decryptData(item.encryptedVIN) : item.vin;
                if(typeof vin_no === 'undefined' || vin_no === '' || vin_no.length < 17) {
                        validVehicles = false;
                }
            });

            return (validDrivers && validVehicles && phone && email);
        };
        
        ctrl.reQuote = function(form){
            $scope.isRequoteButtonClicked = true;//isRequoteButtonClicked
            $scope.countOfInvalidData = 0;//validation for lease & finance options
            form.submitted =true;
            if (!form.valid) {
                return;
            }
            if(!$scope.bindData.contactPhone.value){
                return;
            }
            var reqoutedata = LoadSaveService.saveAndReQuoteSubmission(null,submissionVM.value)
            ModalService.showProgressDialog('quoteandbind.controllers.Please wait', reqoutedata);
            reqoutedata.then(function(reQuotedResponse){
                submissionVM.value = reQuotedResponse;
                // check if there is change in vin details or in license number or
                // state
                var latestVehicles = submissionVM.draftData.lobs.personalAuto.value.vehicles;
                var latestDrivers = submissionVM.draftData.lobs.personalAuto.value.drivers;
                var latestVinArr = [];
                var latestLicenseNumberArr = [];
               
               var isValidVehicle = true;
               var isValidLicense = true;
               
              // All the drivers should have license number in order to proceed
                _.forEach(latestDrivers,function(item){
                    let licenseno = item.isPrefilledDriver ? InMemorySession.decryptData(item.eNCLicenseNumber) : item.licenseNumber;
                    if(licenseno === undefined || licenseno === '' ) {
                        isValidLicense = false
                    }else {
                        latestLicenseNumberArr.push(licenseno);
                    }
                });
    
                if(!isValidLicense) {
                    return;
                }
                
                // for all the vehicles enetrd Vin should be present and valid
                
                _.forEach($scope.vehicleVinValidMap,function(item){
                    if(!item.isValidVin){
                        isValidVehicle = false;
                    }
                });
    
                if(!isValidVehicle) {
                    return;
                }
                //Changed for Short Vin Validation
                _.forEach(latestVehicles,function(item){
                    let vin_no = item.isPrefilledVehicle ? InMemorySession.decryptData(item.encryptedVIN) : item.vin;
                    if(vin_no === undefined || vin_no === '' || vin_no.length < 17) {
                        isValidVehicle = false;
                        $scope.vehicleVinValidMap.push({
                            "publicID": item.publicID,
                            "isValidVin": false
                        });
                    }else {
                        latestVinArr.push(vin_no);
                    }
                });
    
                if(!isValidVehicle) {
                    return;
                }
    
                if(_.isEqual(latestVinArr,vinArray) && _.isEqual(latestLicenseNumberArr,driverLicenseArr)) {
                    flowModel.next(submissionVM);
                }else{
                    $state.go("paRequoteDetails");
                 }
            })
        };

        ctrl.isAccountHolder = (driver)=> {
            return submissionVM.value.getAccountHolderPerson() === driver.person;
        };

        ctrl.lookupPerson = (driver)=> {
            return _.findWhere(submissionVM.submission.persons.value, {publicID: driver.personID});
        };

        ctrl.lookupState = (state)=> {
            let stateName = _.findWhere($scope.states, {code: state});
            if (!stateName) {
                //try the country
                stateName = _.findWhere(InsuranceSuiteMetadata.get('pc').types.getTypelist('Country').codes, {code: state});
            }
            return stateName;
        };

        ctrl.driverSort = (driver)=> {
            if (ctrl.isAccountHolder(driver)) {
                return -1;
            }
            return driver.getDisplayName(undefined, $filter);
        };

        ctrl.lookupVIN = (vehicle) =>{
            if (vehicle.vin.value && vehicle.vin.value.length === 17) {
                if(vehicle.tmpPaType.value === 'motorcycle_aaa'){
                    motorcycleVinLookUp(vehicle);
                }else if(vehicle.tmpPaType.value === 'auto'){
                    autoVinLookUp(vehicle);
                }

            }else{
                if(vehicle.vin.value.length < 17){
                    const vehicleChosen = _.findWhere($scope.vehicleVinValidMap,{publicID: vehicle.value.publicID});
                    if(vehicleChosen === undefined){
                        $scope.vehicleVinValidMap.push({
                            "publicID": vehicle.value.publicID,
                            "isValidVin": false
                        });
                    }else{
                        vehicleChosen.isValidVin = false;
                    }
                }
            }

        };

        function motorcycleVinLookUp(vehicle){
            var hldiDetails = {
                vin: vehicle.vin.value,
                ccr: "ZEM2O9S8F9A1",
                searchType: "Vindicate",
                quoteId: submissionVM.quoteID.value
            };
            //The Bike VIN does not return a match, VIN is invalid
            var bikePromise = VinLookupService.aaaHLDILookup('quoteandbind', hldiDetails);
            var validVIN = false;
            ModalService.showProgressDialog('quoteandbind.controllers.Please wait', bikePromise);
            bikePromise.then(bikeInfo => {
            if (bikeInfo && bikeInfo.vindicatorData.makeName && bikeInfo.vindicatorData.modelName && bikeInfo.vindicatorData.modelYear){
                vehicle.make.value = bikeInfo.vindicatorData.makeName;
                vehicle.model.value = bikeInfo.vindicatorData.modelName;
                vehicle.year.value = bikeInfo.vindicatorData.modelYear.trim();
                vehicle.cCs.value = bikeInfo.vindicatorData.displacement.trim();
                vehicle.bodyStyle.value = bikeInfo.vindicatorData.vehicleClassDesc.trim();
                vehicle.series.value = bikeInfo.vindicatorData.seriesName.trim();
                if(bikeInfo.vindicatorData.basePrice != "" && bikeInfo.vindicatorData.basePrice != undefined &&
                                 bikeInfo.vindicatorData.basePrice.trim() != ""){
                                   vehicle.costNew.amount.value = bikeInfo.vindicatorData.basePrice.trim();
                                }
                validVIN = true;
            }
            const vehicleChosen = _.findWhere($scope.vehicleVinValidMap,{publicID: vehicle.value.publicID});
            if(vehicleChosen === undefined){
                $scope.vehicleVinValidMap.push({
                    "publicID": vehicle.value.publicID,
                    "isValidVin": validVIN
                });
            }else{
                vehicleChosen.isValidVin = validVIN;
            }

        });
    }

        function autoVinLookUp(vehicle){
            var vinDetails =
                {
                    vinNumber: vehicle.vin.value,
                    policyEffectiveDate: $scope.startDate,
                    searchType: "DecodeVinByDate",
                    quoteID: submissionVM.quoteID.value
                }
            var validVIN = false;
            var vehiclePromise = VinLookupService.aaaVINLookup('quoteandbind', vinDetails);
            ModalService.showProgressDialog('quoteandbind.controllers.Please wait', vehiclePromise);
            vehiclePromise.then(vehicleInfo => {
                if (vehicleInfo && vehicleInfo.vehicleData.make && vehicleInfo.vehicleData.fullModelName && vehicleInfo.vehicleData.isoYear) {
                vehicle.make.value = vehicleInfo.vehicleData.make.trim();
                vehicle.model.value = vehicleInfo.vehicleData.fullModelName.trim();
                vehicle.year.value = vehicleInfo.vehicleData.isoYear.trim();
                vehicle.cylinder.value = vehicleInfo.vehicleData.engineCyl.trim();
                vehicle.bodyStyle =  vehicleInfo.vehicleData.bodyStyle.trim();
                
                // New fields addded for the new VIN service approach
                vehicle.vehicleSurchargeCd.value = vehicleInfo.vehicleData.vehicleSurchargeCode.trim();
                vehicle.comprehensiveSymbolCd.value = vehicleInfo.vehicleData.comprehensiveSymbolCd.trim();
                vehicle.collisionSymbolCd.value = vehicleInfo.vehicleData.collisionSymbolCd.trim();
                vehicle.twoDgVSRSymbol.value = vehicleInfo.vehicleData.twoDgVSRSymbol.trim();
                vehicle.bodyType.value = vehicleInfo.vehicleData.bodyType;
                vehicle.paAntiLockBrakes.value = vehicleInfo.vehicleData.paAntiLockBrakes;
                vehicle.paPassiveRestraint.value = vehicleInfo.vehicleData.paPassiveRestraint;
                vehicle.paAntiTheft.value = vehicleInfo.vehicleData.paAntiTheft;
                
                if (vehicleInfo.vehicleData.abs != null && vehicleInfo.vehicleData.abs != undefined){
                    vehicle.abs.value = vehicleInfo.vehicleData.abs.trim();
                }
                
                if (vehicleInfo.vehicleData.antiTheft != null && vehicleInfo.vehicleData.antiTheft != undefined){
                    vehicle.antiTheft.value = vehicleInfo.vehicleData.antiTheft.trim();
                }
                
                if (vehicleInfo.vehicleData.restrInd != null && vehicleInfo.vehicleData.restrInd != undefined){
                    vehicle.restrInd.value = vehicleInfo.vehicleData.restrInd.trim();
                }
                
                // Set cost new if long vin returns cost new
                if (vehicleInfo.vehicleData.costNew && vehicleInfo.vehicleData.costNew.amount){
                    vehicle.costNew.amount.value = vehicleInfo.vehicleData.costNew.amount;
                } 
                
                validVIN = true;
            }
            const vehicleChosen = _.findWhere($scope.vehicleVinValidMap,{publicID: vehicle.value.publicID});
            if(vehicleChosen === undefined){
                $scope.vehicleVinValidMap.push({
                    "publicID": vehicle.value.publicID,
                    "isValidVin": validVIN
                });
            }else{
                vehicleChosen.isValidVin = validVIN;
            }

        });
    }
        
        ctrl.isValidVin = function(vehicle){
        	  const vehicleKey = _.findWhere($scope.vehicleVinValidMap,{publicID: vehicle.value.publicID});
        	  if(vehicleKey){
        		  return vehicleKey.isValidVin;
        	  }else{
        		  return true;
        	  }
        };

        ctrl._setBindDataDefaultValues = () => {
            submissionVM.bindData.value = submissionVM.bindData.value || {};
            if (!submissionVM.bindData.billingAddress.value) {
                submissionVM.bindData.billingAddress.value = {};
                angular.copy(
                    submissionVM.draftData.policyAddress.value,
                    submissionVM.bindData.billingAddress.value
                );
            }
            submissionVM.bindData.contactPhone.value = submissionVM.bindData.contactPhone.value || '';
            submissionVM.bindData.contactEmail.value = submissionVM.bindData.contactEmail.value ||
                submissionVM.draftData.accountHolder.emailAddress1.value;
        };

        ctrl.cancel = function () {
            flowModel.cancel(submissionVM);
        };

        return ctrl.create($scope);
    };
    // added '$rootScope' *Princy UI
    fn.$inject = ['$scope', '$rootScope', '$filter', '$timeout', 'LocaleService', 'InsuranceSuiteMetadata', 'StateUtils', 'submissionViewModel', 'VinLookupService', 'VinLookupEnabled', '$q', 'ModalService','$state','InMemorySession', 'qnb.LoadSaveService','MembershipService'];

    return fn;
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/pa/controllers/PAPolicyInfoCtrl.js
 **/